import React from "react";
import { Modal }  from "react-bootstrap";

export default class AskToUpgradeSafari extends React.Component {
  render () {
    const { show, onHide } = this.props;
    return (
      <Modal show={show}>
        <Modal.Body>
          <h4>
            Please use the latest version of Safari
          </h4>
        </Modal.Body>
        <Modal.Footer>
          <div>
            <button 
              className="btn btn-primary"
              onClick={onHide}
            >
              ok
            </button>
          </div>
        </Modal.Footer>
      </Modal>
    )
  }
}